<div *ngIf="model?.data" class="w-full text-center">
  <div *ngIf="model.data?.fileURL" class="flex justify-center">
    <img [src]="model.data?.fileURL" class="w-48 h-auto"/>
  </div>
  
  <div class="grid grid-cols-{{languages?.length}}" *ngIf="!model.data?.fileURL">
    <div *ngFor="let lang of languages" class="flex justify-center">
        <img [src]="model.data[lang]?.fileURL" class="w-48 h-auto"/>
    </div>
  </div>
</div>